import React,{ useState,useEffect } from 'react'

import Header from '../components/header'
import markersection from "../assets/promotionmaker/1.png";
import { PersistGate } from 'redux-persist/integration/react';
import img1 from "../assets/promotionmaker/1.webp";
import img2 from "../assets/promotionmaker/2.webp";
import img3 from "../assets/promotionmaker/3.webp";
import LazyLoadImage from "react-lazy-load-image-component";
import img4 from "../assets/promotionmaker/2.png";
import img5 from "../assets/promotionmaker/3.png";
import img6 from "../assets/promotionmaker/3.png";

import img7 from "../assets/promotionmaker/6.webp";
import img8 from "../assets/promotionmaker/7.webp";
import img9 from "../assets/promotionmaker/8.webp";

import Button from '@mui/material/Button';
import axios from 'axios';
import Footer from "../components/Footer"
import apiConfig from '../config/api.js';

const Catelog = () => {
    const [data, setData] = useState([]);
    const [img, setImg] = useState(`${img1}`);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${apiConfig.API_URL}/aapi/tempbycat.php?title=Promotion Maker`
                );
                setData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);


    console.log("data-=-=-=-",data)
  return (
    <>
    <Header />
    <div  className='pt-20 bg-[#3556fb]' >

    <div className='catlogContainer'>
        <div>
            <p>Turn Your Photo to Sketch - CV Maker</p>
            <br/>
            <p>Elevate your images to stunning pencil sketches with Fotor's photo to sketch converter. Let our magic sketch filter artify your images effortlessly in just one click!</p>
       
            <br/>
            <p>Elevate your images to stunning pencil sketches with Fotor's photo to sketch converter. Let our magic sketch filter artify your images effortlessly in just one click!</p>
   
            <br/>
            <p>Elevate your images to stunning pencil sketches with Fotor's photo to sketch converter. Let our magic sketch filter artify your images effortlessly in just one click!</p>
   
       
        </div>


        <div></div>
        <div>
            <LazyLoadImage src={`${markersection}`} />
        </div>
    </div>
    </div>
    <p className=' text-[32px] text-center font-[500] mt-10' >Turn Photo into Sketch Using AI Sketch Filters & Effects</p>
    
    <div className='flex justify-center '>
    <div className='text-center' style={{maxWidth:"840px"}}>

    <p>Use our professionally crafted sketch filters and effects to give your photos a lifelike sketching look. Our easy-to-use online photo to sketch converter only takes a couple of seconds to turn a photo into a sketch drawing, with no manual editing. Whether you want to sketch faces, landscapes, or pets, Fotor has you covered!</p>
    </div>
    </div>
    <div className="card-container" style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                {data.map((item) => (
                    <div key={item.id} className="card">
                        <LazyLoadImage 
                            src={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`} 
                            alt={item.title} 
                        />
                        <div className="card-content">
                            <h3>{item.title}</h3>
                            {/* Add additional content here */}
                        </div>
                    </div>
                ))}
            </div>

            <Button variant="contained" className="btn-grad focus:outline-none" style={{margin:"auto", display:"block", borderRadius:"20px", width:"180px", backgroundColor:  "#882ED8"}}>SHOW MORE</Button>

            
    <p className='my-16 text-[32px] text-center font-[500]' >Turn Photo into Sketch Using AI Sketch Filters & Effects</p>


<div className='imageGrid'>
    <div>
        <LazyLoadImage src={`${img}`} />
    </div>
    <div>
        <div onClick={()=> setImg(`${img1}`)}>
            <LazyLoadImage src={`${img1}`} />
        </div>
        <div onClick={()=> setImg(`${img2}`)}>
             <LazyLoadImage src={`${img2}`} />
             </div>
        <div onClick={()=> setImg(`${img3}`)}>
        <imLazyLoadImageg src={`${img3}`} />
        </div>
    </div>
</div>


<div className='catelogTextContainer'>
<div className='catelogText'>
    <p>Use our professionally crafted sketch filters and effects to give your photos a lifelike sketching look. Our easy-to-use online photo to sketch converter only takes a couple of seconds to turn a photo into a sketch drawing, with no manual editing. Whether you want to sketch faces, landscapes, or pets, Fotor has you covered!</p>
   <p>Simply upload your photo, choose a sketch effect you like, and instantly see the magic transformation of turning your photo to art! Your sketch drawing is ready! So, try out the cutting-edge tool now and generate stunning artwork with AI in seconds.</p>
   {/* <Button variant="contained" style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
    </div>
</div>

<div className='catlogSection'>
    <div>
        <LazyLoadImage src={`${img4}`} />
    </div>
    <div></div>
    <div>
        <p>Turn Portrait Photo to Pencil Sketch - Pencil Portrait Sketch</p>
        <p>Want a professional pencil portrait sketch and save time? Use our image to drawing converter, effortlessly convert image to sketch portrait drawing in a few simple steps. It’s not only fast but provides high-definition images as well. Ease yourself and convert photo to sketch online free now with Fotor!</p>
        {/* <Button variant="contained" style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
    </div>
</div>


<div className='catlogSectionTwo'>
    <div>
        <LazyLoadImage src={`${img5}`} />
    </div>
    <div></div>
    <div>
        <p>Turn Portrait Photo to Pencil Sketch - Pencil Portrait Sketch</p>
        <p>Want a professional pencil portrait sketch and save time? Use our image to drawing converter, effortlessly convert image to sketch portrait drawing in a few simple steps. It’s not only fast but provides high-definition images as well. Ease yourself and convert photo to sketch online free now with Fotor!</p>
        {/* <Button variant="contained" style={{marginTop:"10px",width:"180px",borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
    </div>
</div>




<div className='catelogAITexContainer'>
<div className='catelogAIText'>
    <p>AI-assisted Image to Sketch Converter Tailored to Your Needs</p>
    <p>Easily find your perfect photo sketch effect that maximize the enchanting flavor of your photos with our a range of effects from our image to sketch converter. From the mesmerizing pencil sketch to the artistic ink effect, we've got you all covered!</p>
</div>
</div>




<div className='cardContainer' > 
 <div>
    <div>
    <LazyLoadImage src={`${img7}`} />
    </div>
    <div>
        <p>1. Choose Templete</p>
        <p>Convert photo to pencil sketch online free and add extra vibrant and artistic vibe with a single-click.</p>
    </div>
 </div>


 <div>
    <div>
    <LazyLoadImage src={`${img8}`} />
    </div>
    <div>
        <p>2. Edit Templete</p>
        <p>Convert photo to pencil sketch online free and add extra vibrant and artistic vibe with a single-click.</p>
    </div>
 </div>

 <div>
    <div>
    <LazyLoadImage src={`${img9}`} />
    </div>
    <div>
        <p>3. Download </p>
        <p>Convert photo to pencil sketch online free and add extra vibrant and artistic vibe with a single-click.</p>
    </div>
 </div>




</div>
<Footer />



    </>
  )
}

export default Catelog